"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function ArrowLeft(props) {
    return (react_1.default.createElement(react_native_svg_1.default, Object.assign({ width: 20, height: 17, viewBox: "0 0 20 17", fill: "none" }, props),
        react_1.default.createElement(react_native_svg_1.Path, Object.assign({ d: "M18.2 7.3H3.7l5.6-5.5c.5-.5.4-1.1 0-1.5-.2-.2-.4-.3-.7-.3-.3 0-.6.1-.8.3L.3 7.7c-.2.1-.3.4-.3.7 0 .3.1.6.3.8.1.1 7.4 7.3 7.5 7.3.4.4 1.1.4 1.5 0 .2-.2.3-.5.3-.8 0-.3-.1-.5-.3-.8L3.7 9.5h14.5c.7 0 1.1-.6 1.1-1.1 0-.5-.4-1-1.1-1.1z", fill: "#504F4F" }, props))));
}
exports.default = ArrowLeft;
